import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { Assessment } from '../../types/assessment';

const AssessmentEndpoint = 'assessments';
const PublishedAssessmentEndpoint = 'event/assessments';

export const useGetAssessments = (
  params?: string,
  libraryType?: 'admin' | 'library',
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<Assessment>
  >(
    `${!libraryType ? '' : libraryType + '/'}${AssessmentEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetPublishedAssessments = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading } = useSWR<KendoGridResult<Assessment>>(
    `${PublishedAssessmentEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    assessments: data?.data,
    isLoading,
    isError: error
  };
};
